var _style, _path, _path2, _path3, _path4, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNavSubtraction = function SvgNavSubtraction(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#5ac57a",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.9 841.9",
    style: {
      enableBackground: "new 0 0 841.9 841.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M752,56.2c0-19.3-15.7-35-35-35h-70.2c-19.3,0-35,15.7-35,35s15.7,35,35,35H717C736.4,91.2,752,75.5,752,56.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M535.2,21.2H465c-19.3,0-35,15.7-35,35s15.7,35,35,35h70.2c19.3,0,35-15.7,35-35S554.6,21.2,535.2,21.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M791.3,104.4c-19.3,0-35,15.7-35,35v70.2c0,19.3,15.7,35,35,35s35-15.7,35-35v-70.2 C826.3,120,810.6,104.4,791.3,104.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M791.3,280c-19.3,0-35,15.7-35,35v70.2c0,19.3,15.7,35,35,35s35-15.7,35-35V315 C826.3,295.6,810.6,280,791.3,280z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M316.3,526.8c-6.6-6.6-10.3-15.6-10.3-24.9V91.4H83v659.1h673.2V537.1l-414.9,0.1 C331.9,537.1,322.9,533.4,316.3,526.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M816.4,476.8c-6.6-6.6-15.6-10.3-24.9-10.3l-414.9,0.1V56.1c0-19.5-15.8-35.3-35.3-35.3H47.7 c-19.5,0-35.3,15.8-35.3,35.3v729.6c0,19.5,15.8,35.3,35.3,35.3h743.8c19.5,0,35.3-15.8,35.3-35.3v-284 C826.8,492.4,823.1,483.4,816.4,476.8z M756.2,750.5H83V91.4h223v410.5c0,9.4,3.7,18.3,10.3,24.9s15.6,10.3,24.9,10.3l414.9-0.1 V750.5z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavSubtraction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-subtraction.990050c9.svg";
export { ForwardRef as ReactComponent };